package com.flowyride.app

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.flowyride.core.designsystem.theme.FlowyRideTheme
import com.flowyride.core.domain.navigation.ActiveNavigation
import com.flowyride.feature.account.ui.AccountGate
import com.flowyride.feature.navigation.ui.NavigationRoute
import com.flowyride.feature.planner.ui.PlannerRoute
import com.flowyride.feature.settings.ui.SettingsRoute
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

/** Root composable shared by every platform. Requires [com.flowyride.app.di.initKoin]. */
@Composable
fun App() {
    FlowyRideTheme {
        AccountGate(settings = { accountSection, onBack -> SettingsRoute(onBack = onBack, accountSection = accountSection) }) { accountButton ->
            val navigation = koinInject<ActiveNavigation>()
            val request by navigation.request.collectAsStateWithLifecycle()
            val current = request
            if (current == null) {
                PlannerRoute(accountButton = accountButton)
            } else {
                // One view model per navigation: a new ride starts from a clean state.
                key(current.id) { NavigationRoute(viewModel = koinViewModel(key = "navigation-${current.id}")) }
            }
        }
    }
}
